import React, { useState } from "react";

import "@assets/css/components/CollapseToggler.css";
import { Fade } from "reactstrap";

import ShapeNotif from "@pages/layouts/components/notifications/ShapeNotif";

function Index({
  withImage,
  iconInfo,
  withSvg = false,
  content,
  className,
  classDrop,
  classShape,
  classArrow = ""
}) {
  const [open, setOpen] = useState(false);
  const [openShape, setOpenShape] = useState(false);
  const onBlurImage = () => {
    setOpen(!open);
    setOpenShape(!openShape);
  };
  return (
    <div className="custom_tooltips">
      {withImage ? (
        <img
          src={iconInfo}
          alt=""
          className="info_content"
          onMouseEnter={onBlurImage}
          onMouseLeave={onBlurImage}
        />
      ) : (
        ""
      )}

      {withSvg && (
        <div
          onMouseEnter={onBlurImage}
          onMouseLeave={onBlurImage}
        >
          {withSvg}
        </div>
      )}
      <div className="shape_notif_content">
        <ShapeNotif
          classParent={` ${classShape} container_shape_up_notif`}
          shapeNotif={openShape}
          classArrow={` ${classArrow} arrow-up`}
          // mouseleave={this.closeModalNotification}
        />
      </div>
      <Fade in={open}>
        <ul
          className={`dropdown_select ${classDrop}`}
          onMouseLeave={onBlurImage}
        >
          <li
            className={`d-flex mb_bottom list regular ${className}`}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {content}
          </li>
        </ul>
      </Fade>
    </div>
  );
}

export default Index;
